import { render, staticRenderFns } from "./RedeemCodeGiftPage.vue?vue&type=template&id=5bed96b3&scoped=true"
import script from "./RedeemCodeGiftPage.vue?vue&type=script&lang=js"
export * from "./RedeemCodeGiftPage.vue?vue&type=script&lang=js"
import style0 from "./RedeemCodeGiftPage.vue?vue&type=style&index=0&id=5bed96b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed96b3",
  null
  
)

export default component.exports